<template>
  <b-container fluid class="header" v-if="help">
    <b-jumbotron fluid>
      <h2 class='text-white'>Website</h2>
      <p class='text-white'>Edit your hosting information</p>
      <b-button @click='help = !help'>Get started</b-button>
    </b-jumbotron>

    <b-container class="mt-4">
      <b-card title="Domains" class="mb-4">
        Setup an A-record with your DNS provider to point your domain name to your website.
      </b-card>
    </b-container>
  </b-container>

  <b-container fluid v-else>
    <div class="horizontal-menu">
      <b-row>
        <b-col>
          <h2>Website</h2>
        </b-col>
        <b-col class="float-right">
          <b-button class="float-right" variant="transparent" @click="help = !help"><i class="far fa-question-circle"></i></b-button>
        </b-col>
      </b-row>

      <b-nav>
        <b-nav-item :to="{name: 'domains'}" exact exact-active-class="tab_active">Settings</b-nav-item>
      </b-nav>
    </div>

    <router-view :profile="profile" :user="user" :site="site" />
  </b-container>
</template>

<script>
import { db } from '@/main.js'

export default {
  name: 'website',
  props: ['profile', 'user', 'site'],
  data() {
    return {
      help: this.site.help.website
    }
  },
  watch: {
    help(val) {
      if (this.site.help.website && !val) {
        db.collection('site').doc(this.site.id).update({'help.website': false})
      }
    }
  },
}
</script>

<style>

</style>
